import { JobStatusEnum, useSendTranscriptionStatusSubscription } from '@/types/generated/graphql';
import { notification } from 'antd';
import { updateTranscriptionStatusInCache } from '../utils/transcription-handler.utils';
import { useTranslation } from 'react-i18next';
import { cacheUpdateAiReports } from '@/graphql/cache/cache-mutations';

export function useTranscriptionStatusSubscription() {
  const { t } = useTranslation();
  useSendTranscriptionStatusSubscription({
    onData: ({ data }) => {
      const payload = data.data?.sendTranscriptionStatus;
      if (!payload) return;
      const { jobStatus, providerCallRecordingsId, id } = payload;
      updateTranscriptionStatusInCache(providerCallRecordingsId, id, jobStatus);
      cacheUpdateAiReports();

      if (jobStatus === JobStatusEnum.IN_PROGRESS) {
        notification.info({
          message: t('transcription_process_has_started_please_wait_for_sometime_to_download_the_transcribed_script'),
        });
      }

      if (jobStatus === JobStatusEnum.COMPLETED) {
        notification.success({
          message: t('your_ai_powered_call_transcription_has_been_completed_please_download_report'),
        });
      }
    },
  });
}
